module.exports = __webpack_public_path__ + "static/btn-whatsapp-e90911d6c9b25c50ba5fe0c1a3e455f1.png";